import {create} from "zustand/index";
import * as protocolServices from "../../services/protocols"
import {TCompanyId} from "@/common/types";
import {IProtocolDefStats} from "../../types/IProtocolDefStats";
import {IProtocolStats} from "../../types/IProtocolStats";
import {TProtocolDefinitionId} from "../../../types/protocolDefinitions";

export interface IDashboardState {
    protocolDefStats: Array<IProtocolDefStats>
    protocolStats: Array<IProtocolStats>
    loadingProtocolDefStats: boolean
    loadingProtocolStats: boolean
}

export interface IDashboardActions {
    reset: () => void
    loadProtocolDefStats: (companyId: TCompanyId) => Promise<Array<IProtocolDefStats>>
    loadProtocolStats: (companyId: TCompanyId, pdefId : TProtocolDefinitionId) => Promise<Array<IProtocolStats>>
}

export const useDashboardStore = create<IDashboardState & IDashboardActions>((set, get, store) => {
    return ({
        protocolDefStats: [],
        protocolStats: [],
        loadingProtocolDefStats: false,
        loadingProtocolStats: false,
        reset: () => set(store.getInitialState()),
        loadProtocolDefStats: async (companyId: TCompanyId) => {
            const data = await protocolServices.loadProtocolDefStats(companyId).finally(() => {
                set((state) => ({loadingProtocolDefStats: false}))
            })
            set((state) => ({protocolDefStats: data}))
            return get().protocolDefStats
        },
        loadProtocolStats: async (companyId: TCompanyId, pdefId : TProtocolDefinitionId) => {
            const data = await protocolServices.loadProtocolStats(companyId, pdefId).finally(() => {
                set((state) => ({loadingProtocolStats: false}))
            })
            set((state) => ({protocolStats: data}))
            return get().protocolStats
        }
    })
})